import { get } from '../../utils/api';
import { appActions } from '../../commons/reducer';
import { takeLatest, spawn, put } from 'redux-saga/effects';
import { TRACKING_NUMBER, trackingActions } from './reducer';

function* trackingNumber() {
  yield takeLatest(
    TRACKING_NUMBER.GET_TRACKING_NUMBER_STATUS,
    function* fn(action: any): any {
      try {
        const response = yield get(
          `/shipping/tracking?trackingNumber=${action.trackingNumber}`,
        );
        if (!response.success) {
          yield put(
            trackingActions.getTrackingNumberFailed({
              response,
            }),
          );
        } else {
          yield put(trackingActions.getTrackingNumberSuccess(response.data));
        }
      } catch {
        yield put(appActions.serverFailed('Oops, server failed'));
      }
    },
  );
}

export default function* saga(): any {
  yield spawn(trackingNumber);
}
